<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Parameter Name"
                      v-model="formSchema.parameter_name"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Parameter Title"
                      v-model="formSchema.parameter_title"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-select
                      label="Parameter Type"
                      item-text="name"
                      item-value="name"
                      v-model="formSchema.parameter_type"
                      :items="parameterTypes"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-select>
                  </v-flex>

                 <!--  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field label="Table Name" v-model="formSchema.table_name"></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field label="Column Ref 1" v-model="formSchema.column_ref_1"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field label="Column Ref 2" v-model="formSchema.column_ref_2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>

                  <!-- Add by bulbul -->
                  <v-flex xs12 sm12 md12 class="pr-4" v-if="formSchema.parameter_type == 'LIST'">
                    <v-textarea
                    label="Raw Sql Query (Hins: SELECT * FROM ...)"
                    v-model="formSchema.raw_sql_query"
                    ></v-textarea>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="info" flat @click.native="close({message:'Form Reseted !',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1,
    roleList: [],
    parameterTypes: [
      { name: "TEXT" },
      { name: "DATE" },
      { name: "INT" },
      { name: "LIST" }
    ]
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Report Parameter Master"
        : "Add Report Parameter Master";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {},

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      console.log(formSchema);

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "parameter_master")
            .then(res => {
              let actionData = {
                message: res.message,
                status: res.status
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "parameter_master")
            .then(res => {
              let actionData = {
                message: res.message,
                status: res.status
              };
              this.close(actionData);
            });
        }
      }
    },
    // Close Function
    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitCloseModal", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/report/parameter_master/parameter_master_form.vue